import { Paper, Typography, Box } from '@mui/material';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, LabelList } from 'recharts';

interface Props {
  data: { date: string; count: number }[];
}

const DailyTrendChart = ({ data }: Props) => {
  const total = data.reduce((s, d) => s + d.count, 0);

  return (
    <Paper elevation={0} sx={{
      p: { xs: 2, md: 3 }, borderRadius: 3,
      border: '1px solid #e5e7eb', height: '100%',
    }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Typography fontWeight={700} sx={{ fontSize: '0.95rem', color: '#0f172a' }}>
          최근 7일 신청 추이
        </Typography>
        <Typography sx={{ fontSize: '0.82rem', fontWeight: 700, color: '#1976d2' }}>
          총 {total}건
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
        일별 신규 신청 건수
      </Typography>
      <Box sx={{ width: '100%', height: 220 }}>
        <ResponsiveContainer>
          <BarChart data={data} barCategoryGap="25%">
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 12, fill: '#94a3b8' }}
              axisLine={false} tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 12, fill: '#94a3b8' }}
              axisLine={false} tickLine={false}
              allowDecimals={false}
            />
            <Tooltip
              contentStyle={{
                borderRadius: 10, border: '1px solid #e5e7eb',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)', fontSize: '0.85rem',
              }}
              formatter={(value: number) => [`${value}건`, '신청']}
            />
            <Bar
              dataKey="count"
              fill="#1976d2"
              radius={[4, 4, 0, 0]}
              maxBarSize={40}
            >
              <LabelList
                dataKey="count"
                position="top"
                style={{ fontSize: '0.7rem', fontWeight: 700, fill: '#64748b' }}
                formatter={(v: number) => (v > 0 ? `${v}` : '')}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default DailyTrendChart;
